(function () {
	const initSlider = (message) => {
		const slider = message.querySelector('.announcement-bar__swiper');

		if (!slider || slider.swiper) return;

		if (slider.querySelectorAll('.swiper-slide').length < 2) return;

		const prevBtn = message.querySelector('.announcement-bar__nav--prev');
		const nextBtn = message.querySelector('.announcement-bar__nav--next');

		const swiperParams = {
			slidesPerView: 1,
			speed: 600,
			allowTouchMove: true,
			loop: slider.getAttribute('data-loop') === 'true'
		};

		if (slider.getAttribute('data-navigation') === 'true' && prevBtn && nextBtn) {
			swiperParams.navigation = {
				prevEl: prevBtn,
				nextEl: nextBtn
			};
		}

		if (slider.getAttribute('data-autoplay') === 'true') {
			swiperParams.autoplay = {
				disableOnInteraction: false,
				pauseOnMouseEnter: true
			};
		}

		new Swiper(slider, swiperParams);
	};

	const initSection = () => {
		document.querySelectorAll('.announcement-bar__message').forEach((message) => initSlider(message));
	};

	initSection();

	document.addEventListener('shopify:section:load', initSection);
})();
